export default {"src":"/_next/static/media/triangle.c7eb2faf.svg","height":292,"width":292,"blurWidth":0,"blurHeight":0};